<template>
  <div>
    <div class="type-list">
      <div class="type-item" v-for="(item, index) in makeType" :key="index"
        ><span
          class="i-color"
          :style="{ backgroundColor: item.attr_color }"
        ></span
        ><span class="i-text">{{ item.name }}</span></div
      >
    </div>
    <div class="table">
      <div class="t-head">
        <div
          class="head-item"
          :class="{ 'item-first': index == 0 }"
          v-for="(item, index) in tableHead"
          :key="index"
        >
          <div class="head-name">{{ item.text }}</div>
          <div class="head-time">{{ item.time }}</div>
        </div>
      </div>
      <div class="t-body">
        <div class="t-day" v-for="(item, index) in data" :key="index">
          <div class="t-tr">
            <div class="t-td item-first">
              <div class="td-day">第{{ item.day }}天</div>
            </div>
            <div class="t-right">
              <div class="t-tr t-package">
                <div
                  class="t-td"
                  v-for="(item1, index1) in item.data"
                  :key="index1"
                >
                  <div>{{ item1.meal_data.brand_name }}</div>
                  <div>{{ item1.meal_data.package_name }}</div>
                </div>
              </div>
              <div class="t-tr">
                <div
                  class="t-td"
                  v-for="(item1, index1) in item.data"
                  :key="index1"
                >
                  <div class="food-list">
                    <div
                      class="food-item"
                      v-for="(item2, index2) in item1.meal_data.food_list"
                      :key="index2"
                    >
                      <div
                        :style="{ color: getFoodColor(item2.food_attr_ids) }"
                      >
                        <span class="food-name">{{ item2.name }} </span
                        ><span class="food-unit" v-if="item2.food_weight"
                          >{{ item2.food_weight | filterUnitNumber
                          }}{{ item2.specs_name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    filterUnitNumber(num) {
      num = +num
      return num == 0.5 ? '半' : num
    }
  },
  data() {
    return {
      makeData: [],
      tableHead: [
        {
          text: '时间',
          width: '11.9%'
        },
        {
          text: '早餐',
          time: '（6:30-9:30）'
        },
        {
          text: '午餐',
          time: '（11:30-14:30）'
        },
        {
          text: '晚餐',
          time: '（17:30-19:30）'
        }
      ]
    }
  },
  computed: {
    makeType() {
      let list = this.$store.state.cnaV2.scienceFoodAttr || []
      list = [].concat(list)
      list.push({
        attr_color: '#CB78BD',
        attr_cron: '',
        id: list.length + 1,
        name: '包含以上某些食物属性'
      })
      return list
    }
  },
  methods: {
    getFoodColor(attr) {
      let typeList = {}
      this.makeType.map((item) => {
        typeList[item.id] = item
      })
      if (
        (attr && !Array.isArray(attr)) ||
        (attr && Array.isArray(attr) && attr.length == 1)
      ) {
        return typeList[attr].attr_color
      } else {
        return this.makeType[this.makeType.length - 1].attr_color
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.type-list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 3px;

  .type-item {
    margin-right: 10px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;

    .i-color {
      width: 10px;
      height: 8px;
      background: #5483c8;
      margin-right: 4px;
    }

    .i-text {
      white-space: nowrap;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 14px;
    }
  }

  .type-item:last-child {
    margin-right: 0;
  }
}

.table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #c4e8e2;

  .t-head {
    background: #39bba5;
    display: flex;
    align-items: stretch;

    .head-item {
      flex: 1;
      box-sizing: border-box;
      padding: 5px 2px;
      text-align: center;
      border-right: 1px solid #c4e8e2;

      .head-name {
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 12px;
      }

      .head-time {
        font-size: 9px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 12px;
      }
    }

    .head-item:last-child {
      border-right: none;
    }
  }

  .t-body {
    .t-day {
      .t-tr {
        display: flex;

        .t-td {
          box-sizing: border-box;
          flex: 1;
          padding: 8px;
          border-right: 1px solid #c4e8e2;
          border-bottom: 1px solid #c4e8e2;

          .td-day {
            font-size: 10px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 12px;
          }
        }

        .t-td:last-child {
          border-right: none;
        }

        .t-right {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }
      }

      .t-package {
        background: #eff6fc;
        font-size: 9px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #777777;
        line-height: 14px;
      }

      .food-list {
        .food-item {
          font-size: 9px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #5483c8;
          line-height: 9px;
          margin-bottom: 8px;

          .food-name,
          .group-item {
            word-break: break-all;
            word-wrap: break-word;
            white-space: normal;
          }

          .food-unit {
            white-space: nowrap;
          }
        }

        .food-item:last-child {
          margin-bottom: 0;
        }
      }
    }

    .t-day:last-child {
      .t-tr:last-child {
        .t-td {
          border-bottom: none !important;
        }
      }
    }
  }

  .item-first {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 0 0 11.9% !important;
    padding: 10px 2px !important;
  }
}
</style>
